import { render, staticRenderFns } from "./NavigationBottom.vue?vue&type=template&id=6468ad16&scoped=true&"
import script from "./NavigationBottom.vue?vue&type=script&lang=js&"
export * from "./NavigationBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6468ad16",
  null
  
)

export default component.exports